var _g, _path, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbroad06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "travelling",
    xmlns: "http://www.w3.org/2000/svg",
    width: 101.7,
    height: 101.7,
    viewBox: "0 0 101.7 101.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2805",
    "data-name": "Group 2805",
    transform: "translate(4.197 58.343)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5035",
    "data-name": "Path 5035",
    d: "M37.094,311.816,21.978,299.927a1.845,1.845,0,0,1-.6-2.435h0c2.423-3.509,7.09-4.707,11.675-3l13.671,7.755Z",
    transform: "translate(-21.13 -293.724)",
    fill: "#f9b316"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5036",
    "data-name": "Path 5036",
    d: "M127.039,371.618l11.921,15.147a1.845,1.845,0,0,0,2.435.6l.9-.622c2.968-2.049,3.981-6,2.536-9.875l-8.194-14.849Z",
    transform: "translate(-106.002 -348.453)",
    fill: "#f9b316"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5037",
    "data-name": "Path 5037",
    d: "M71.437,311.655l-8.552,8.5,7.67,6.033,9.63-9.568Z",
    transform: "translate(-50.394 -249.75)",
    fill: "#e7a000"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2806",
    "data-name": "Group 2806",
    transform: "translate(22.726 10.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5038",
    "data-name": "Path 5038",
    d: "M115.942,73.341h0a5.23,5.23,0,0,1-.353-7c2.426-2.977,5.465-6.291,7.288-8.114,2.494-2.494,2.712-2.2,5.377-3.829a1,1,0,0,1,1.224.143l5.27,5.27a1,1,0,0,1,.143,1.224c-1.633,2.665-1.335,2.882-3.829,5.376-1.823,1.823-5.138,4.862-8.114,7.288A5.231,5.231,0,0,1,115.942,73.341Z",
    transform: "translate(-114.412 -54.246)",
    fill: "#c3d3db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5039",
    "data-name": "Path 5039",
    d: "M355.446,312.845h0a5.23,5.23,0,0,1-.353-7c2.426-2.977,5.465-6.291,7.288-8.114,2.494-2.494,2.712-2.2,5.377-3.829a1,1,0,0,1,1.224.143l5.27,5.27a1,1,0,0,1,.143,1.224c-1.633,2.665-1.335,2.882-3.829,5.377-1.823,1.823-5.138,4.862-8.114,7.288A5.231,5.231,0,0,1,355.446,312.845Z",
    transform: "translate(-306.342 -246.176)",
    fill: "#c3d3db"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5040",
    "data-name": "Path 5040",
    d: "M48.055,91.9,66.7,73.249,8.933,55.1a3.267,3.267,0,0,0-3.159.772L.893,60.751c-1.635,1.635-.933,4.631,1.375,5.87Z",
    transform: "translate(-0.001 -44.059)",
    fill: "#f9b316"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5041",
    "data-name": "Path 5041",
    d: "M202.927,126.308l-16.649,16.649,11.053,6.1,18.649-18.649Z",
    transform: "translate(-149.277 -101.219)",
    fill: "#e7a000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5042",
    "data-name": "Path 5042",
    d: "M271.16,194.841l18.649-18.649,18.151,57.771a3.267,3.267,0,0,1-.772,3.159L302.307,242c-1.635,1.635-4.631.933-5.87-1.375Z",
    transform: "translate(-217.299 -141.194)",
    fill: "#f9b316"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5043",
    "data-name": "Path 5043",
    d: "M149.2,27.158l-31.33,31.33a169.821,169.821,0,0,1-16.7,14.649L86.262,84.572c-3.451,2.647-7.555,2.968-9.761.762h0c-2.206-2.206-1.886-6.31.762-9.761L88.7,60.666a169.821,169.821,0,0,1,14.649-16.7l31.33-31.33a52.032,52.032,0,0,1,14.4-10.3c4.475-2.11,9.232-3.431,11.542-1.121s.989,7.067-1.121,11.542A52.022,52.022,0,0,1,149.2,27.158Z",
    transform: "translate(-60.134 0)",
    fill: "#e0f3fc"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5044",
    "data-name": "Path 5044",
    d: "M160.861,1.237A4.583,4.583,0,0,0,157.63.025c.094,2.406-.95,5.458-2.332,8.389a52.025,52.025,0,0,1-10.3,14.4l-31.33,31.33a169.794,169.794,0,0,1-16.7,14.649L82.064,80.226A9.523,9.523,0,0,1,75.343,82.4a5.059,5.059,0,0,0,1.4,2.953h0c2.206,2.206,6.31,1.886,9.761-.762l14.906-11.435a169.818,169.818,0,0,0,16.7-14.649l31.33-31.33a52.032,52.032,0,0,0,10.3-14.4C161.85,8.3,163.171,3.548,160.861,1.237Z",
    transform: "translate(-60.378 -0.02)",
    fill: "#c3d3db"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5045",
    "data-name": "Path 5045",
    d: "M412.031,58.848l-1.07,1.07c-.994.994-12.108-10.121-11.114-11.114l1.07-1.07a2.248,2.248,0,0,1,2.47-.53h0a18.312,18.312,0,0,1,9.175,9.175h0A2.248,2.248,0,0,1,412.031,58.848Z",
    transform: "translate(-320.374 -37.69)",
    fill: "#f9b316"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5046",
    "data-name": "Path 5046",
    d: "M93.43,355.555a1.49,1.49,0,0,1-1.053-2.543L105.386,340a1.49,1.49,0,0,1,2.107,2.107l-13.01,13.01A1.485,1.485,0,0,1,93.43,355.555Z",
    transform: "translate(-73.678 -272.117)",
    fill: "#f9b316"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbroad06);
export default __webpack_public_path__ + "static/media/abroad-06.f5a00fcf27a2e0819abbe640276f9910.svg";
export { ForwardRef as ReactComponent };